import React, { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

const RefNumberField = ({ record }) => {
  const [formattedRequestIdChange, setFormattedRequestIdChange] = useState("Loading...");
  const dataProvider = useDataProvider();

  const getFormattedRequestIdChange = async () => {
    try {
      const prevRecord = JSON.parse(record.oldValues);
      const currentRecord = JSON.parse(record.newValues);
      const prev = prevRecord?.RequestId;
      const current = currentRecord?.RequestId;

      const prevData =
        prev > 0
          ? (
              await dataProvider.getList("pbhrequestorders/getpbhrequestlist", {
                pagination: { page: 1, perPage: 500 },
                sort: { field: "id", order: "ASC" },
                filter: { id__eq: prev },
              })
            )?.data?.[0]?.refNo
          : "";

      const currentData =
        current > 0
          ? (
              await dataProvider.getList("pbhrequestorders/getpbhrequestlist", {
                pagination: { page: 1, perPage: 500 },
                sort: { field: "id", order: "ASC" },
                filter: { id__eq: current },
              })
            )?.data?.[0]?.refNo
          : "";

      if (prev === current) {
        setFormattedRequestIdChange("Not Changed");
      } else {
        setFormattedRequestIdChange(`${prevData} ---> ${currentData}`);
      }
    } catch (error) {
      console.error("Error fetching request id:", error);
      setFormattedRequestIdChange("Error");
    }
  };

  useEffect(() => {
    if (record) {
      getFormattedRequestIdChange();
    }
  }, [record]);

  return <span>{formattedRequestIdChange}</span>;
};

export default RefNumberField;
